import { ImagePickerFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";

const blockBackgroundImageField = {
    displayName: "Background Image",
    editorTemplate: "ImagePickerField",
    defaultValue: "",
    fieldType: "Translatable",
} as ImagePickerFieldDefinition;

export default blockBackgroundImageField;
